import Card from "components/card";

const Widget = ({ icon, title, subtitle }) => {
  return (
    <Card extra="!flex-row flex-grow items-center rounded-[20px] p-0 border border-white/70 dark:border-white/50">
      <div className="relative widget-header-title flex h-[80px] w-[80px] flex-row items-center">
        
        <div className="absolute w-full">
          <div className="absolute top-[-40px] right-[-15px]">
            <div className="curved-corner-topright"/>
          </div>
        </div>
        <div className="rounded-full p-3 bg-lightPrimary dark:bg-darkSecondary/50">
          <span className="flex items-center text-theme-500 dark:text-white">
            {icon}
          </span>
        </div>
      </div>

      <div className="h-50 ml-4 flex w-auto flex-col justify-center">
        <p className="font-outfit text-sm font-medium text-gray-800 dark:text-gray-100">{title}</p>
        <h4 className="text-xl font-bold text-theme-700 dark:text-white">
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;
